(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3661],{

/***/ 56029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),

/***/ 53325:
/***/ (function(module) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 84753:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseExtremum = __webpack_require__(56029),
    baseGt = __webpack_require__(53325),
    baseIteratee = __webpack_require__(67206);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 67381:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prediction/leaderboard",
      function () {
        return __webpack_require__(31543);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89145);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51847);
/* harmony import */ var _util_getPortalRoot__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70032);









var BaseMenu = function BaseMenu(param) {
    var component = param.component, options = param.options, children = param.children, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), targetElement = ref[0], setTargetElement = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), menuElement = ref1[0], setMenuElement = ref1[1];
    var ref2;
    var placement = (ref2 = options === null || options === void 0 ? void 0 : options.placement) !== null && ref2 !== void 0 ? ref2 : "bottom";
    var ref3;
    var offset = (ref3 = options === null || options === void 0 ? void 0 : options.offset) !== null && ref3 !== void 0 ? ref3 : [
        0,
        10
    ];
    var ref4;
    var padding = (ref4 = options === null || options === void 0 ? void 0 : options.padding) !== null && ref4 !== void 0 ? ref4 : {
        left: 16,
        right: 16
    };
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen), isMenuOpen = ref5[0], setIsMenuOpen = ref5[1];
    var toggle = function toggle() {
        setIsMenuOpen(function(prev) {
            return !prev;
        });
    };
    var open = function open() {
        setIsMenuOpen(true);
    };
    var close = function close() {
        setIsMenuOpen(false);
    };
    // Allow for component to be controlled
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsMenuOpen(isOpen);
    }, [
        isOpen,
        setIsMenuOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (menuElement !== null && targetElement !== null) {
            var handleClickOutside = function handleClickOutside(param) {
                var target = param.target;
                if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(target, Node) && !menuElement.contains(target) && !targetElement.contains(target)) {
                    setIsMenuOpen(false);
                }
            };
            document.addEventListener("click", handleClickOutside);
            return function() {
                document.removeEventListener("click", handleClickOutside);
            };
        }
        return undefined;
    }, [
        menuElement,
        targetElement
    ]);
    var ref6 = (0,react_popper__WEBPACK_IMPORTED_MODULE_4__/* .usePopper */ .D)(targetElement, menuElement, {
        placement: placement,
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: padding
                }
            }, 
        ]
    }), styles = ref6.styles, attributes = ref6.attributes;
    var menu = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        ref: setMenuElement,
        style: styles.popper
    }, attributes.popper), {
        children: typeof children === "function" ? children({
            toggle: toggle,
            open: open,
            close: close
        }) : children
    }));
    var portal = (0,_util_getPortalRoot__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)();
    var renderMenu = portal ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(menu, portal) : menu;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_8__/* .ClickableElementContainer */ .j5, {
                ref: setTargetElement,
                onClick: toggle,
                children: component
            }),
            isMenuOpen && renderMenu
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BaseMenu);


/***/ }),

/***/ 42906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _BaseMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32115);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51847);







var SubMenu = function SubMenu(_param) {
    var children = _param.children, component = _param.component, options = _param.options, _isOpen = _param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "component",
        "options",
        "isOpen"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BaseMenu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        component: component,
        options: options,
        isOpen: isOpen,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styles__WEBPACK_IMPORTED_MODULE_4__/* .SubMenuContainer */ .lz, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
            children: children
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SubMenu);


/***/ }),

/***/ 51847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j5": function() { return /* binding */ ClickableElementContainer; },
/* harmony export */   "lz": function() { return /* binding */ SubMenuContainer; },
/* harmony export */   "vE": function() { return /* binding */ SubMenuItem; },
/* harmony export */   "xm": function() { return /* binding */ InlineMenuContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43859);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44147);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75943);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  flex-direction: column;\n  overflow: hidden;\n  min-width: 136px;\n  background: ",
        ";\n  border-radius: 12px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  background: transparent;\n  padding: 8px 16px;\n  color: ",
        ";\n  width: 100%;\n  height: 45px;\n  font-size: 14px;\n  text-align: left;\n\n  &:hover {\n    background-color: ",
        ";\n    text-decoration: none;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var InlineMenuContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e35eb6f0-0"
}).withConfig({
    componentId: "sc-20029055-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.shadows.tooltip;
});
var SubMenuContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-e35eb6f0-1"
}).withConfig({
    componentId: "sc-20029055-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
});
var ClickableElementContainer = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e35eb6f0-2"
}).withConfig({
    componentId: "sc-20029055-2"
})(_templateObject2());
var SubMenuItem = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].button.withConfig */ .ZP.button.withConfig({
    componentId: "sc-e35eb6f0-3"
}).withConfig({
    componentId: "sc-20029055-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});


/***/ }),

/***/ 32762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43859);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6704);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 16px;\n  box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  border: 1px solid ",
        ";\n\n  &::placeholder {\n    color: ",
        ";\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-c22a9310-0"
}).withConfig({
    componentId: "sc-39f22014-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 6704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 44417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Spinner_Spinner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Svg.tsx
var Svg = __webpack_require__(44976);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/MummyIcon.tsx





var Icon = function Icon(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Svg/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_185_997)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
                        fill: "#101233"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M8.6112 20.6592C8.6112 20.6592 9.69744 19.9124 12.0072 19.9124C14.317 19.9124 15.4037 20.6592 15.4037 20.6592C15.4037 20.6592 15.0869 21.0605 14.7062 21.1805C14.3256 21.3005 13.8187 21.1877 13.1846 21.6384C12.5506 22.0892 12.0072 22.0402 12.0072 22.0402C12.0072 22.0402 11.4638 22.0882 10.8302 21.6384C10.1966 21.1887 9.6888 21.3 9.30816 21.1805C8.92752 21.061 8.6112 20.6592 8.6112 20.6592Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M11.2022 4.45097C10.5456 4.41497 9.6144 4.49369 9.0576 4.29593C8.10672 3.95993 7.9536 3.61961 7.14864 3.78857C6.56112 3.91193 6.42144 4.37225 6.36336 4.84025C7.788 4.58441 8.604 4.91513 8.604 4.91513C6.5568 5.13353 5.8632 5.68745 5.82 5.72201C5.76594 5.77048 5.72092 5.82818 5.68704 5.89241C5.6208 6.03305 5.67216 6.08441 5.68416 6.36185C8.52864 5.49785 10.801 6.09785 10.801 6.09785C8.72736 6.14585 6.78864 6.50633 4.93344 7.40729L5.20608 8.36201C6.912 7.74713 7.872 8.18489 7.872 8.18489C6.85265 8.43059 5.87011 8.80953 4.94976 9.31193L5.12496 9.75449C4.72944 10.0583 4.40496 11.1921 4.40496 11.1921C4.30896 10.5791 4.69296 9.73385 4.69296 9.73385C3.88992 9.78185 3.58896 10.5441 3.58896 11.1782C3.58896 11.8122 3.99552 12.5279 4.48848 12.9935C4.98144 13.4591 5.09424 13.9727 5.09424 13.9727C5.46816 12.9508 4.74192 12.8687 4.93968 11.6548C5.13744 10.4409 6.59472 9.79529 6.59472 9.79529C6.29549 9.7294 5.99177 9.68591 5.68608 9.66521C6.31344 9.56921 6.75264 8.56409 10.6392 11.0889C14.5258 13.6137 16.9325 11.0596 18.2232 10.2868C18.6072 10.6002 19.0085 11.0596 19.1054 11.6548C19.3027 12.8668 18.5774 12.9508 18.9504 13.9727C18.9504 13.9727 19.0632 13.4586 19.5562 12.9935C20.0491 12.5284 20.4581 11.8098 20.4581 11.1762C20.4581 10.5426 20.1552 9.78137 19.3517 9.73193C19.3517 9.73193 19.7395 10.5772 19.6397 11.1902C19.6397 11.1902 19.3037 10.0142 18.8966 9.73673L19.1102 9.19817L18.912 9.05705C16.1448 7.37945 12.0072 7.43993 12.0072 7.43993C16.0152 7.08761 18.8453 8.37977 18.8453 8.37977L19.081 7.41065L18.3552 7.05593C18.3552 7.05593 18.3869 6.36425 18.2669 6.11033C18.1963 5.96057 17.9904 5.81321 17.8349 5.71769C16.3272 5.05577 13.7333 4.91513 13.7333 4.91513C16.0426 4.70153 17.1893 4.84409 17.6515 4.93961C17.5714 4.45289 17.3635 3.73481 16.8418 3.62489C16.5 3.55289 16.2754 3.57257 16.057 3.64553C15.961 3.53561 15.6638 3.21593 15.3178 3.10697C14.8973 2.97449 14.3366 3.09881 13.6378 2.60057C12.9389 2.10233 12.336 2.15705 12.336 2.15705C12.336 2.15705 11.7355 2.10281 11.0347 2.60105C10.3339 3.09929 9.77328 2.97497 9.35472 3.10745C8.93616 3.23993 8.58384 3.68345 8.58384 3.68345C8.58384 3.68345 9.42816 4.26329 11.2056 4.45145L11.2022 4.45097Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M12.0072 19.5255C12.0072 19.5255 10.0344 19.5327 9.08304 19.8707C8.13168 20.2086 7.97904 20.547 7.17408 20.378C6.58608 20.2542 6.46128 19.7348 6.4032 19.2663C7.82784 19.5227 8.604 19.0883 8.604 19.0883C6.5568 18.8694 5.8632 18.3155 5.82 18.2814C5.76594 18.2329 5.72092 18.1752 5.68704 18.111C5.6208 17.9699 5.64288 17.8758 5.65488 17.5988C8.49984 18.4619 10.8 17.9041 10.8 17.9041C8.7264 17.8561 6.78768 17.4956 4.93248 16.5947L5.2152 15.5343C6.9912 15.9798 7.8696 15.8185 7.8696 15.8185C6.85059 15.5734 5.86836 15.1949 4.94832 14.6929L5.172 14.1289C8.04576 15.3011 15.9662 15.3011 18.84 14.1289L19.1078 14.8052L18.912 14.9459C16.1448 16.6259 12.0072 16.5654 12.0072 16.5654C16.0152 16.9177 18.8453 15.6255 18.8453 15.6255L19.081 16.5947L18.3552 16.947C18.3552 16.947 18.4469 17.8556 18.3269 18.1095C18.2563 18.2588 18.0504 18.4062 17.8949 18.5017C16.3872 19.1641 13.7333 19.0878 13.7333 19.0878C16.0426 19.3014 17.1715 19.3254 17.6318 19.2318C17.5517 19.7185 17.365 20.2695 16.8418 20.3799C16.0382 20.5489 15.8818 20.211 14.9323 19.8726C13.9829 19.5342 12.0082 19.5275 12.0082 19.5275L12.0072 19.5255Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M7.716 11.7808C7.716 11.7808 7.3488 12.6635 8.06832 13.0158C8.78784 13.3681 10.595 13.19 10.595 13.19C10.595 13.19 9.02832 12.0352 7.71504 11.7808H7.716Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.6718 12.6868C16.6718 12.6868 16.8125 13.4193 16.2067 13.5743C15.601 13.7293 14.2483 13.3069 14.2483 13.3069C14.2483 13.3069 15.6288 12.6719 16.6718 12.6868Z",
                        fill: "white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.2446 7.45142C19.2446 7.45142 20.6146 7.54118 21.4488 8.0087C22.1722 8.41334 22.8763 9.3455 22.8763 9.3455C22.8763 9.3455 21.8429 9.67094 21.5213 10.0492C21.2261 10.3977 21.1651 10.5556 21.1651 10.5556C21.1651 10.5556 20.401 9.00854 19.0243 8.44022L19.2446 7.45142Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.9752 20.2392C16.9752 20.2392 17.6539 20.8339 18.2592 21.0072C18.7838 21.1551 19.5446 21.0495 19.5446 21.0495C19.5446 21.0495 19.2154 20.4178 19.2418 20.0923C19.2662 19.7928 19.3114 19.6911 19.3114 19.6911C18.7339 19.6113 18.1692 19.4571 17.6314 19.2322L16.9752 20.2392Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M4.93392 14.0026C4.93392 14.0026 3.90144 14.9079 2.9808 15.168C2.18304 15.3927 1.02576 15.2319 1.02576 15.2319C1.02576 15.2319 1.52688 14.2704 1.488 13.776C1.45056 13.321 1.38192 13.166 1.38192 13.166C1.38192 13.166 3.01632 13.7199 4.39152 13.1482L4.93392 14.0026Z",
                        fill: "#03F5AE"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M8.496 3.59516C8.496 3.59516 7.73088 3.03452 7.41792 2.45228C7.14672 1.94828 7.08192 1.14332 7.08192 1.14332C7.08192 1.14332 7.80528 1.33532 8.13312 1.23596C8.43456 1.14236 8.52864 1.07324 8.52864 1.07324C8.52864 1.07324 8.4 2.25836 8.9904 3.10028L8.496 3.59516Z",
                        fill: "#03F5AE"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_185_997",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var MummyIcon = (Icon);

;// CONCATENATED MODULE: ./packages/uikit/src/components/Spinner/Spinner.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  svg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 80px;\n    height: 80px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n\n    transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100px;\n  height: 100px;\n  border-radius: 999px;\n  border: 3px solid #34f5ae;\n  border-top-color: transparent;\n  animation: ",
        " 1s linear infinite forwards;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e4aa583-0"
}).withConfig({
    componentId: "sc-5e8d5f4e-0"
})(_templateObject());
var loading = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var Loader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5e4aa583-1"
}).withConfig({
    componentId: "sc-5e8d5f4e-1"
})(_templateObject2(), loading);
var Spinner = function Spinner() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MummyIcon, {})
        ]
    });
};
/* harmony default export */ var Spinner_Spinner = (Spinner);


/***/ }),

/***/ 39853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Td": function() { return /* binding */ Td; },
/* harmony export */   "Th": function() { return /* binding */ Th; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43859);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* border-bottom: 1px solid ",
        "; */\n  color: ",
        ";\n  /* padding: 16px; */\n  vertical-align: middle;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  text-transform: uppercase;\n  height: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Td = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].td.withConfig */ .ZP.td.withConfig({
    componentId: "sc-b51b3f0f-0"
}).withConfig({
    componentId: "sc-7fa90089-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .typography */ .cp);
var Th = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(Td).attrs({
    as: "th"
}).withConfig({
    componentId: "sc-b51b3f0f-1"
}).withConfig({
    componentId: "sc-7fa90089-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});


/***/ }),

/***/ 44391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43859);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);
/* harmony import */ var _Cell__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39853);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 100%;\n  width: 100%;\n\n  tbody tr:last-child {\n    ",
        " {\n      border-bottom: 0;\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Table = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].table.withConfig */ .ZP.table.withConfig({
    componentId: "sc-4fe367f7-0"
}).withConfig({
    componentId: "sc-b0f07fdc-0"
})(_templateObject(), _Cell__WEBPACK_IMPORTED_MODULE_3__.Td, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
/* harmony default export */ __webpack_exports__["Z"] = (Table);


/***/ }),

/***/ 91125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useTooltip_useTooltip__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88896);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75943);






var InfoTooltip = function InfoTooltip(_param) {
    var text = _param.text, _iconColor = _param.iconColor, iconColor = _iconColor === void 0 ? "textSubtle" : _iconColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "text",
        "iconColor"
    ]);
    var ref = (0,_hooks_useTooltip_useTooltip__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(text, {}), targetRef = ref.targetRef, tooltip = ref.tooltip, tooltipVisible = ref.tooltipVisible;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props), {
        alignItems: "center",
        children: [
            tooltipVisible && tooltip,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                ref: targetRef,
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    alt: "info",
                    src: "/images/leaderboard/infoIcon.svg"
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InfoTooltip);


/***/ }),

/***/ 88896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useTooltip_useTooltip; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs
var features_animation = __webpack_require__(1673);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 52 modules
var usePopper = __webpack_require__(89145);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
// EXTERNAL MODULE: ./packages/uikit/src/theme/dark.ts + 9 modules
var dark = __webpack_require__(73712);
// EXTERNAL MODULE: ./packages/uikit/src/util/getPortalRoot.ts
var getPortalRoot = __webpack_require__(70032);
// EXTERNAL MODULE: ./packages/uikit/src/util/isTouchDevice.ts
var isTouchDevice = __webpack_require__(44047);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs
var motion_minimal = __webpack_require__(12560);
;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/StyledTooltip.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  &,\n  &::before {\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 2px;\n    z-index: -1;\n  }\n\n  &::before {\n    content: "";\n    transform: rotate(45deg);\n    background: ',
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n  font-size: 14px;\n  line-height: 130%;\n  border-radius: 16px;\n  max-width: 320px;\n  z-index: 101;\n  background: ",
        ";\n  color: ",
        ";\n  box-shadow: ",
        ';\n\n  &[data-popper-placement^="top"] > ',
        ' {\n    bottom: -4px;\n  }\n\n  &[data-popper-placement^="bottom"] > ',
        ' {\n    top: -4px;\n  }\n\n  &[data-popper-placement^="left"] > ',
        ' {\n    right: -4px;\n  }\n\n  &[data-popper-placement^="right"] > ',
        " {\n    left: -4px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Arrow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-56798bdd-0"
}).withConfig({
    componentId: "sc-3a2294de-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
});
var StyledTooltip = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-56798bdd-1"
}).withConfig({
    componentId: "sc-3a2294de-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.tooltip.background;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.text;
}, function(param) {
    var theme = param.theme;
    return theme.tooltip.boxShadow;
}, Arrow, Arrow, Arrow, Arrow);

;// CONCATENATED MODULE: ./packages/uikit/src/hooks/useTooltip/useTooltip.tsx













var animationVariants = {
    initial: {
        opacity: 0
    },
    animate: {
        opacity: 1
    },
    exit: {
        opacity: 0
    }
};
var animationMap = {
    initial: "initial",
    animate: "animate",
    exit: "exit"
};
var invertTheme = function invertTheme(currentTheme) {
    if (currentTheme.isDark) {
        return dark/* default */.Z;
    }
    return dark/* default */.Z;
};
var useTooltip = function useTooltip(content, options) {
    var _placement = options.placement, placement = _placement === void 0 ? "auto" : _placement, _trigger = options.trigger, trigger = _trigger === void 0 ? "hover" : _trigger, _arrowPadding = options.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 16 : _arrowPadding, _tooltipPadding = options.tooltipPadding, tooltipPadding = _tooltipPadding === void 0 ? {
        left: 16,
        right: 16
    } : _tooltipPadding, _tooltipOffset = options.tooltipOffset, tooltipOffset = _tooltipOffset === void 0 ? [
        0,
        10
    ] : _tooltipOffset, _hideTimeout = options.hideTimeout, hideTimeout = _hideTimeout === void 0 ? 100 : _hideTimeout;
    var ref = (0,react.useState)(null), targetElement = ref[0], setTargetElement = ref[1];
    var ref1 = (0,react.useState)(null), tooltipElement = ref1[0], setTooltipElement = ref1[1];
    var ref2 = (0,react.useState)(null), arrowElement = ref2[0], setArrowElement = ref2[1];
    var ref3 = (0,react.useState)(false), visible = ref3[0], setVisible = ref3[1];
    var isHoveringOverTooltip = (0,react.useRef)(false);
    var hideTimeoutRef = (0,react.useRef)();
    var hideTooltip = (0,react.useCallback)(function(e) {
        var hide = function hide() {
            e.stopPropagation();
            e.preventDefault();
            setVisible(false);
        };
        if (trigger === "hover") {
            if (hideTimeoutRef.current) {
                window.clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = false;
            }
            if (!isHoveringOverTooltip.current) {
                hideTimeoutRef.current = window.setTimeout(function() {
                    if (!isHoveringOverTooltip.current) {
                        hide();
                    }
                }, hideTimeout);
            }
        } else {
            hide();
        }
    }, [
        tooltipElement,
        trigger,
        hideTimeout
    ]);
    var showTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        e.preventDefault();
        setVisible(true);
        if (trigger === "hover") {
            if (e.target === targetElement) {
                // If we were about to close the tooltip and got back to it
                // then prevent closing it.
                clearTimeout(hideTimeoutRef.current);
            }
            if (e.target === tooltipElement) {
                isHoveringOverTooltip.current = true;
            }
        }
    }, [
        tooltipElement,
        targetElement,
        trigger
    ]);
    var toggleTooltip = (0,react.useCallback)(function(e) {
        e.stopPropagation();
        setVisible(!visible);
    }, [
        visible
    ]);
    // Trigger = hover
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "hover") return undefined;
        if ((0,isTouchDevice/* default */.Z)()) {
            targetElement.addEventListener("touchstart", showTooltip);
            targetElement.addEventListener("touchend", hideTooltip);
        } else {
            targetElement.addEventListener("mouseenter", showTooltip);
            targetElement.addEventListener("mouseleave", hideTooltip);
        }
        return function() {
            targetElement.removeEventListener("touchstart", showTooltip);
            targetElement.removeEventListener("touchend", hideTooltip);
            targetElement.removeEventListener("mouseenter", showTooltip);
            targetElement.removeEventListener("mouseleave", showTooltip);
        };
    }, [
        trigger,
        targetElement,
        hideTooltip,
        showTooltip
    ]);
    // Keep tooltip open when cursor moves from the targetElement to the tooltip
    (0,react.useEffect)(function() {
        if (tooltipElement === null || trigger !== "hover") return undefined;
        tooltipElement.addEventListener("mouseenter", showTooltip);
        tooltipElement.addEventListener("mouseleave", hideTooltip);
        return function() {
            tooltipElement.removeEventListener("mouseenter", showTooltip);
            tooltipElement.removeEventListener("mouseleave", hideTooltip);
        };
    }, [
        trigger,
        tooltipElement,
        hideTooltip,
        showTooltip
    ]);
    // Trigger = click
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "click") return undefined;
        targetElement.addEventListener("click", toggleTooltip);
        return function() {
            return targetElement.removeEventListener("click", toggleTooltip);
        };
    }, [
        trigger,
        targetElement,
        visible,
        toggleTooltip
    ]);
    // Handle click outside
    (0,react.useEffect)(function() {
        if (trigger !== "click") return undefined;
        var handleClickOutside = function handleClickOutside(param) {
            var target = param.target;
            if ((0,_instanceof/* default */.Z)(target, Node)) {
                if (tooltipElement != null && targetElement != null && !tooltipElement.contains(target) && !targetElement.contains(target)) {
                    setVisible(false);
                }
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            return document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        trigger,
        targetElement,
        tooltipElement
    ]);
    // Trigger = focus
    (0,react.useEffect)(function() {
        if (targetElement === null || trigger !== "focus") return undefined;
        targetElement.addEventListener("focus", showTooltip);
        targetElement.addEventListener("blur", hideTooltip);
        return function() {
            targetElement.removeEventListener("focus", showTooltip);
            targetElement.removeEventListener("blur", hideTooltip);
        };
    }, [
        trigger,
        targetElement,
        showTooltip,
        hideTooltip
    ]);
    // On small screens Popper.js tries to squeeze the tooltip to available space without overflowing beyond the edge
    // of the screen. While it works fine when the element is in the middle of the screen it does not handle well the
    // cases when the target element is very close to the edge of the screen - no margin is applied between the tooltip
    // and the screen edge.
    // preventOverflow mitigates this behaviour, default 16px paddings on left and right solve the problem for all screen sizes
    // that we support.
    // Note that in the farm page where there are tooltips very close to the edge of the screen this padding works perfectly
    // even on the iPhone 5 screen (320px wide), BUT in the storybook with the contrived example ScreenEdges example
    // iPhone 5 behaves differently overflowing beyond the edge. All paddings are identical so I have no idea why it is,
    // and fixing that seems like a very bad use of time.
    var ref4 = (0,usePopper/* usePopper */.D)(targetElement, tooltipElement, {
        placement: placement,
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement,
                    padding: arrowPadding
                }
            },
            {
                name: "offset",
                options: {
                    offset: tooltipOffset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: tooltipPadding
                }
            }, 
        ]
    }), styles = ref4.styles, attributes = ref4.attributes;
    var tooltip = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTooltip, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, animationMap), {
        variants: animationVariants,
        transition: {
            duration: 0.3
        },
        ref: setTooltipElement,
        style: styles.popper
    }), attributes.popper), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: invertTheme,
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Arrow, {
                ref: setArrowElement,
                style: styles.arrow
            })
        ]
    }));
    var AnimatedTooltip = /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
        features: features_animation/* domAnimation */.H,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
            children: visible && tooltip
        })
    });
    var portal = (0,getPortalRoot/* default */.Z)();
    var tooltipInPortal = portal ? /*#__PURE__*/ (0,react_dom.createPortal)(AnimatedTooltip, portal) : null;
    return {
        targetRef: setTargetElement,
        tooltip: tooltipInPortal !== null && tooltipInPortal !== void 0 ? tooltipInPortal : AnimatedTooltip,
        tooltipVisible: visible
    };
};
/* harmony default export */ var useTooltip_useTooltip = (useTooltip);


/***/ }),

/***/ 15260:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * Truncate a transaction or address hash
 */ var truncateHash = function(address) {
    var startLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 4, endLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    if (!address) return "";
    return "".concat(address.substring(0, startLength), "...").concat(address.substring(address.length - endLength));
};
/* harmony default export */ __webpack_exports__["Z"] = (truncateHash);


/***/ }),

/***/ 32711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75943);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62077);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32762);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(44147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43859);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97119);
/* harmony import */ var _pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52775);
/* harmony import */ var components_Loader_CircleLoader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83743);






function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background: ",
        ";\n  border-radius: 0 0 8px 8px;\n  left: 0;\n  padding-bottom: 8px;\n  padding-top: 16px;\n  position: absolute;\n  top: calc(100% - 2px);\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  width: 100%;\n  z-index: 99;\n  box-shadow: 0px 20px 32px rgb(231 82 65 / 10%);\n  /* border: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: none; */\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: var(--Base-Unit-XS-8, 8px);\n  border: 1px solid var(--Border, rgba(255, 255, 255, 0.1));\n  background: var(--Nature-1, #191b2e);\n  position: relative;\n  border-radius: 8px;\n  height: 48px;\n\n  input {\n    position: absolute !important;\n    inset: 0;\n    background: transparent;\n    border: none;\n    outline: none;\n    border-radius: 12px;\n    padding-left: 50px;\n    height: 48px;\n    font-size: 16px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: rgba(255, 255, 255, 0.6);\n    &::placeholder {\n      color: #ffffff99;\n    }\n    &:focus {\n      box-shadow: none !important;\n    }\n  }\n\n  svg {\n    position: absolute !important;\n    top: 50%;\n    left: 12px;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  overflow-wrap: break-word;\n  font-weight: bold;\n  padding-left: 16px;\n  padding-right: 16px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var ResultStatus;
(function(ResultStatus) {
    ResultStatus[ResultStatus["NOT_VALID"] = 0] = "NOT_VALID";
    ResultStatus[ResultStatus["FOUND"] = 1] = "FOUND";
    ResultStatus[ResultStatus["NOT_FOUND"] = 2] = "NOT_FOUND";
})(ResultStatus || (ResultStatus = {}));
var SubMenu = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1d6f2339-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
}, function(param) {
    var isOpen = param.isOpen;
    return isOpen && "\n    height: auto;\n    opacity: 1;\n    transform: scaleY(1);\n  ";
});
var StyledSearchBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1d6f2339-1"
})(_templateObject1());
var AddressLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).withConfig({
    componentId: "sc-1d6f2339-2"
})(_templateObject2());
var initialState = {
    isFetching: false,
    resultFound: ResultStatus.NOT_VALID,
    value: ""
};
var defaultValidAddressHandler = function() {
    return Promise.resolve(true);
};
var AddressInputSelect = function(_param) {
    var _onValidAddress = _param.onValidAddress, onValidAddress = _onValidAddress === void 0 ? defaultValidAddressHandler : _onValidAddress, onAddressClick = _param.onAddressClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "onValidAddress",
        "onAddressClick"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(initialState), state = ref[0], setState = ref[1];
    var t = (0,_pancakeswap_localization__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)().t;
    var isFetching = state.isFetching, resultFound = state.resultFound, value = state.value;
    var handleChange = function(evt) {
        var _target = evt.target, newValue = _target.value;
        setState(function(prevState) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prevState), {
                value: newValue
            });
        });
    };
    var handleClick = function() {
        setState(initialState);
        onAddressClick(state.value);
    };
    // When we have a valid address fetch the data
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var isValidAddress = (0,utils__WEBPACK_IMPORTED_MODULE_3__/* .isAddress */ .UJ)(value) !== false;
        var validAddressHandler = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
                var hasResults, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            setState(function(prevState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prevState), {
                                    isFetching: true
                                });
                            });
                            return [
                                4,
                                onValidAddress(value)
                            ];
                        case 1:
                            hasResults = _state.sent();
                            setState(function(prevState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prevState), {
                                    isFetching: false,
                                    resultFound: hasResults ? ResultStatus.FOUND : ResultStatus.NOT_FOUND
                                });
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            setState(function(prevState) {
                                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prevState), {
                                    isFetching: false
                                });
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function validAddressHandler() {
                return _ref.apply(this, arguments);
            };
        }();
        if (isValidAddress) {
            validAddressHandler();
        } else {
            setState(function(prevState) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, prevState), {
                    resultFound: ResultStatus.NOT_VALID
                });
            });
        }
    }, [
        value,
        onValidAddress,
        setState
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSearchBox, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
        position: "relative"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                width: "25",
                height: "24",
                viewBox: "0 0 25 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                    d: "M10.4823 1.43994C5.98039 1.43994 2.32227 5.09807 2.32227 9.59994C2.32227 14.1018 5.98039 17.7599 10.4823 17.7599C12.2635 17.7599 13.9098 17.1862 15.2523 16.2149L21.5673 22.5149L22.9173 21.1649L16.6773 14.9099C17.9035 13.4812 18.6423 11.6268 18.6423 9.59994C18.6423 5.09807 14.9841 1.43994 10.4823 1.43994ZM10.4823 2.39994C14.4648 2.39994 17.6823 5.61744 17.6823 9.59994C17.6823 13.5824 14.4648 16.7999 10.4823 16.7999C6.49977 16.7999 3.28227 13.5824 3.28227 9.59994C3.28227 5.61744 6.49977 2.39994 10.4823 2.39994Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                placeholder: t("Search %subject%", {
                    subject: t("Address")
                }),
                value: state.value,
                onChange: handleChange,
                style: {
                    position: "relative",
                    zIndex: 16,
                    paddingRight: "40px",
                    color: "#FFFFFF99"
                }
            }),
            isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                position: "absolute",
                top: "15px",
                right: "38px",
                style: {
                    zIndex: 17
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Loader_CircleLoader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {})
            }),
            !isFetching && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubMenu, {
                isOpen: state.value !== "",
                children: resultFound === ResultStatus.FOUND ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(AddressLink, {
                    onClick: handleClick,
                    children: state.value
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    px: "16px",
                    fontWeight: "bold",
                    children: "No results found."
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AddressInputSelect);


/***/ }),

/***/ 83743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CircleLoader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43859);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  animation: 2s ",
        " linear infinite;\n  height: ",
        ";\n  width: ",
        ";\n  path {\n    stroke: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var rotate = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)(_templateObject());
var StyledSVG = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].svg.withConfig */ .ZP.svg.withConfig({
    componentId: "sc-fa227f0-0"
})(_templateObject1(), rotate, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var stroke = param.stroke, theme = param.theme;
    return stroke !== null && stroke !== void 0 ? stroke : theme.colors.primary;
});
/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */ function CircleLoader(_param) {
    var _size = _param.size, size = _size === void 0 ? "16px" : _size, stroke = _param.stroke, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "size",
        "stroke"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSVG, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        size: size,
        stroke: stroke
    }, rest), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
            d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 9.27455 20.9097 6.80375 19.1414 5",
            strokeWidth: "2.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
}


/***/ }),

/***/ 71476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43859);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44417);
/* harmony import */ var _Layout_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27553);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_Layout_Page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-5ad34a86-0"
})(_templateObject());
var PageLoader = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Wrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageLoader);


/***/ }),

/***/ 67274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeader.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  padding-bottom: 32px;\n  position: relative;\n  @media screen and (max-width: 700px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Outer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-76f65dd3-0"
})(_templateObject(), function(param) {
    var background = param.background;
    return background || "transparent";
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-76f65dd3-1"
})(_templateObject1());
var PageHeader = function(_param) /*#__PURE__*/ {
    var background = _param.background, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "background",
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Outer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: background
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {
            children: children
        })
    }));
};
/* harmony default export */ var PageHeader_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/components/PageHeader/index.ts




/***/ }),

/***/ 76688:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43859);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44147);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62077);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 145px;\n  @media screen and (max-width: 700px) {\n    width: 100%;\n  }\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px;\n  border: 1px solid var(--Border, rgba(255, 255, 255, 0.1));\n  border-radius: 8px;\n  background: #191b2e;\n  transition: border-radius 0.15s;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 140%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  min-width: 136px;\n  height: 0;\n  position: absolute;\n  overflow: hidden;\n  background: ",
        ";\n  z-index: ",
        ";\n  transition: transform 0.15s, opacity 0.15s;\n  transform: scaleY(0);\n  transform-origin: top;\n  opacity: 0;\n  width: 100%;\n\n  /* ",
        " {\n    min-width: 168px;\n  } */\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        " {\n        border-bottom: 1px solid ",
        ";\n        box-shadow: ",
        ";\n        border-radius: 8px 8px 0 0;\n      }\n\n      ",
        " {\n        height: auto;\n        transform: scaleY(1);\n        opacity: 1;\n        /* border: 1px solid ",
        "; */\n        border-top-width: 0;\n        border-radius: 0 0 8px 8px;\n        box-shadow: ",
        ";\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  width: 100%;\n  position: relative;\n  /* background: ",
        "; */\n  border-radius: 8px;\n  height: 45px;\n  min-width: 136px;\n  user-select: none;\n  z-index: 20;\n\n  /* ",
        " {\n    min-width: 168px;\n  } */\n\n  ",
        "\n\n  svg {\n    position: absolute;\n    right: 16px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  z-index: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  list-style: none;\n  padding: 8px 16px;\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var DropDownHeader = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ce24f44-0"
})(_templateObject());
var DropDownListContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ce24f44-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.cardHeaderBg;
}, function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var DropDownContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ce24f44-2"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
}, function(props) {
    return props.isOpen && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2(), DropDownHeader, function(param) {
        var theme = param.theme;
        return theme.colors.white10;
    }, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    }, DropDownListContainer, function(param) {
        var theme = param.theme;
        return theme.colors.inputSecondary;
    }, function(param) {
        var theme = param.theme;
        return theme.tooltip.boxShadow;
    });
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-ce24f44-3"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.zIndices.dropdown;
});
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-ce24f44-4"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var Select = function(_param) {
    var options = _param.options, onOptionChange = _param.onOptionChange, _defaultOptionIndex = _param.defaultOptionIndex, defaultOptionIndex = _defaultOptionIndex === void 0 ? 0 : _defaultOptionIndex, placeHolderText = _param.placeHolderText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "options",
        "onOptionChange",
        "defaultOptionIndex",
        "placeHolderText"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), optionSelected = ref1[0], setOptionSelected = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(defaultOptionIndex), selectedOptionIndex = ref2[0], setSelectedOptionIndex = ref2[1];
    var toggling = function(event) {
        setIsOpen(!isOpen);
        event.stopPropagation();
    };
    var onOptionClicked = function(selectedIndex) {
        return function() {
            setSelectedOptionIndex(selectedIndex);
            setIsOpen(false);
            setOptionSelected(true);
            if (onOptionChange) {
                onOptionChange(options[selectedIndex]);
            }
        };
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var handleClickOutside = function() {
            setIsOpen(false);
        };
        document.addEventListener("click", handleClickOutside);
        return function() {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (defaultOptionIndex) {
            setSelectedOptionIndex(defaultOptionIndex - 1);
            setOptionSelected(true);
        }
    }, [
        defaultOptionIndex
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DropDownContainer, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        isOpen: isOpen
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownHeader, {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    color: !optionSelected && placeHolderText ? "text" : undefined,
                    children: !optionSelected && placeHolderText ? placeHolderText : options[selectedOptionIndex].label
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                onClick: toggling,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
                        d: "M9.18501 14.2696C9.58365 14.8306 10.4167 14.8306 10.8153 14.2696L14.6515 8.87099C15.122 8.20887 14.6486 7.29175 13.8363 7.29175L6.164 7.29175C5.35175 7.29175 4.87836 8.20888 5.34884 8.87099L9.18501 14.2696Z",
                        fill: "white"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownListContainer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DropDownList, {
                    children: options.map(function(option, index) {
                        return placeHolderText || index !== selectedOptionIndex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ListItem, {
                            onClick: onOptionClicked(index),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                children: option.label
                            })
                        }, option.label) : null;
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Select);


/***/ }),

/***/ 31543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ leaderboard_Leaderboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/views/Predictions/context/PredictionConfigProviders.tsx + 2 modules
var PredictionConfigProviders = __webpack_require__(63322);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/wagmi/src/index.ts + 2 modules
var src = __webpack_require__(74836);
// EXTERNAL MODULE: ./src/contexts/LocalRedux/useLocalDispatch.ts
var useLocalDispatch = __webpack_require__(29807);
// EXTERNAL MODULE: ./src/state/predictions/hooks.ts + 2 modules
var hooks = __webpack_require__(89890);
// EXTERNAL MODULE: ./src/state/predictions/index.ts
var predictions = __webpack_require__(24179);
// EXTERNAL MODULE: ./src/components/Loader/PageLoader.tsx
var PageLoader = __webpack_require__(71476);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(27553);
// EXTERNAL MODULE: ./src/config/constants/types.ts
var types = __webpack_require__(75759);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(43859);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var localization_src = __webpack_require__(52775);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(69589);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(98553);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowBack.tsx
var ArrowBack = __webpack_require__(87844);
// EXTERNAL MODULE: ./src/components/PageHeader/index.ts + 1 modules
var PageHeader = __webpack_require__(67274);
;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Hero.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 700;\n  color: white;\n  margin-top: 94px;\n  font-size: 48px;\n  align-items: flex-start;\n  display: flex;\n  gap: 24px;\n  margin-bottom: 16px;\n  @media (max-width: 991px) {\n    margin-top: 80px;\n  }\n  @media (max-width: 767px) {\n    transform: translateX(0);\n    font-size: 36px;\n    margin-bottom: 0;\n    flex-direction: column;\n    gap: 16px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border-radius: var(--Base-Unit-S-12, 12px);\n  border: 1px solid var(--Border, rgba(255, 255, 255, 0.1));\n  background: var(--HighLight, rgba(255, 255, 255, 0.1));\n  margin-top: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 400;\n  margin-top: 4px;\n  line-height: 140%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledHeading = (0,styled_components_browser_esm/* default */.ZP)(Heading/* default */.Z).withConfig({
    componentId: "sc-3250af85-0"
})(_templateObject());
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-3250af85-1"
})(_templateObject1());
var StyleDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3250af85-2"
})(_templateObject2());
var Wrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-3250af85-3"
})(_templateObject3());
var Hero = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeading, {
            as: "h1",
            scale: "xxl",
            color: "secondary",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                    as: "a",
                    href: "/prediction",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {
                        color: "white",
                        width: "24px"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
                    children: [
                        t("Leaderboard"),
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleDesc, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: "Discover the elite ranks of our leaderboard, where greatness is measured and champions emerge."
                                }),
                                "Only claimed rounds are counted for winning-related data."
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(59637);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(34701);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44147);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(75943);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Grid.tsx
var Grid = __webpack_require__(66260);
// EXTERNAL MODULE: ./src/state/predictions/helpers.ts + 6 modules
var helpers = __webpack_require__(79279);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(44305);
// EXTERNAL MODULE: ./packages/uikit/src/components/Table/Cell.tsx
var Cell = __webpack_require__(39853);
// EXTERNAL MODULE: ./packages/uikit/src/components/Table/Table.tsx
var Table = __webpack_require__(44391);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(62077);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/useModal.ts
var useModal = __webpack_require__(21812);
// EXTERNAL MODULE: ./packages/uikit/src/components/BaseMenu/SubMenu.tsx
var SubMenu = __webpack_require__(42906);
// EXTERNAL MODULE: ./packages/uikit/src/components/BaseMenu/styles.tsx
var styles = __webpack_require__(51847);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(98768);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(97119);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 2 modules
var profile_hooks = __webpack_require__(72007);
// EXTERNAL MODULE: ./packages/utils/truncateHash.ts
var truncateHash = __webpack_require__(15260);
// EXTERNAL MODULE: ./src/views/Predictions/context/ConfigProvider.tsx
var ConfigProvider = __webpack_require__(65238);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/LinkExternal.tsx
var LinkExternal = __webpack_require__(40735);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(89663);
// EXTERNAL MODULE: ./packages/uikit/src/widgets/Modal/styles.tsx
var Modal_styles = __webpack_require__(15426);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(62685);
// EXTERNAL MODULE: ./src/hooks/useTheme.ts
var useTheme = __webpack_require__(63850);
// EXTERNAL MODULE: ./packages/uikit/src/components/Timeline/InfoTooltip.tsx
var InfoTooltip = __webpack_require__(91125);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowUp.tsx
var ArrowUp = __webpack_require__(40696);
// EXTERNAL MODULE: ./packages/uikit/src/components/Svg/Icons/ArrowDown.tsx
var ArrowDown = __webpack_require__(45203);
// EXTERNAL MODULE: ./src/state/types.ts
var state_types = __webpack_require__(96470);
;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/PositionLabel.tsx

function PositionLabel_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  border-radius: 8px;\n  display: inline-flex;\n  justify-content: center;\n  width: fit-content;\n  height: 36px;\n  padding: 8px 12px;\n  min-width: 16px;\n  padding-left: 8px;\n  padding-right: 8px;\n  @media screen and (max-width: 700px) {\n    width: 40px;\n    height: 32px;\n  }\n"
    ]);
    PositionLabel_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PositionLabel_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  display: none;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 700;\n\n  @media screen and (min-width: 768px) {\n    display: block;\n    margin-left: 4px;\n  }\n"
    ]);
    PositionLabel_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledPositionLabel = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9f972f5-0"
})(PositionLabel_templateObject(), function(param) {
    var theme = param.theme, bgColor = param.bgColor;
    return theme.colors[bgColor];
});
var Label = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b9f972f5-1"
})(PositionLabel_templateObject1(), function(param) {
    var isBull = param.isBull;
    return isBull ? "#000" : "#fff";
});
var PositionLabel = function(param) {
    var position = param.position;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isBull = position === state_types/* BetPosition.BULL */.Tu.BULL;
    var bgColor = isBull ? "success" : "failure";
    var icon = isBull ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowUp/* default */.Z, {
        width: "16px",
        color: "black"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDown/* default */.Z, {
        width: "16px",
        color: "white"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledPositionLabel, {
        bgColor: bgColor,
        children: [
            icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                isBull: isBull,
                children: isBull ? t("Up") : t("Down")
            })
        ]
    });
};
/* harmony default export */ var components_PositionLabel = (PositionLabel);

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./src/utils/legacy.ts
function arrayURLFetcher() {
    for(var _len = arguments.length, urlArr = new Array(_len), _key = 0; _key < _len; _key++){
        urlArr[_key] = arguments[_key];
    }
    var fetcher = function(url) {
        return fetch(url).then(function(res) {
            return res.json();
        });
    };
    return Promise.all(urlArr.map(fetcher));
}

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/styles.tsx









var Row = function(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "space-between"
    }, props), {
        children: children
    }));
};
var NetWinnings = function(props) {
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinningsView, (0,_object_spread/* default */.Z)({
        token: token
    }, props));
};
var NetWinningsView = function(_param) {
    var token = _param.token, amount = _param.amount, _textPrefix = _param.textPrefix, textPrefix = _textPrefix === void 0 ? "" : _textPrefix, _textColor = _param.textColor, textColor = _textColor === void 0 ? "text" : _textColor, hiddenTokenName = _param.hiddenTokenName, props = (0,_object_without_properties/* default */.Z)(_param, [
        "token",
        "amount",
        "textPrefix",
        "textColor",
        "hiddenTokenName"
    ]);
    var ref, ref1;
    var ref2 = (0,dist/* default */.ZP)("https://api.mummy.finance/api/tokens/info?symbols=FTM,MMY&chain=FANTOM", {
        fetcher: arrayURLFetcher
    }), tokenInfo = ref2.data;
    var value = (tokenInfo === null || tokenInfo === void 0 ? void 0 : (ref = tokenInfo[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.FTM) === null || ref1 === void 0 ? void 0 : ref1.price) * amount || 0;
    // console.log('???value', value)
    if (!amount && amount !== 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "flex-end"
    }, props), {
        style: {
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                fontWeight: props.fontWeight || "bold",
                color: textColor,
                fontSize: props.fontSize || "14px",
                children: [
                    "".concat(textPrefix).concat(Number(amount).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })),
                    " ",
                    hiddenTokenName ? "" : "FTM"
                ]
            }),
            value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                className: "txt-dollar",
                fontSize: props.subFontSize || "14px",
                color: props.subFontColor || "white60",
                // lineHeight={}
                fontWeight: props.subFontWeight || "400",
                style: {
                    marginLeft: " 4px"
                },
                children: " $".concat(Math.abs(value).toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                }))
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                className: "txt-dollar",
                fontSize: props.subFontSize || "14px",
                color: props.subFontColor || "white60",
                // lineHeight={}
                fontWeight: props.subFontWeight || "400",
                style: {
                    marginLeft: " 4px"
                },
                children: [
                    " ",
                    amount === 0 ? "$0.00" : "$--"
                ]
            })
        ]
    }));
};
var NetWinningsRow = function(param) {
    var amount = param.amount;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
        mb: "8px",
        alignItems: "flex-start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                fontSize: "14px",
                color: "white60",
                children: t("PnL")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinnings, {
                subFontSize: "12px",
                fontWeight: "700",
                alignItems: "center",
                // flexDirection="column"
                amount: amount,
                textPrefix: amount > 0 ? "+" : "",
                textColor: amount > 0 ? "success" : "failure"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/PreviousBetsTable.tsx



function PreviousBetsTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 12px 16px;\n  border-radius: var(--Base-Unit-S-12, 12px);\n  border: 1px solid var(--Border, rgba(255, 255, 255, 0.1));\n  .skeleton-box {\n    display: inline-block;\n    height: 1em;\n    width: 100%;\n    border-radius: 4px;\n    position: relative;\n    overflow: hidden;\n    background-color: rgba(255, 255, 255, 0.05);\n    color: transparent !important;\n\n    > * {\n      display: none;\n    }\n\n    &::after {\n      position: absolute;\n      inset: 0;\n      transform: translateX(-100%);\n      background: linear-gradient(\n        90deg,\n        rgba(255, 255, 255, 0) 0,\n        rgba(202, 202, 202, 0.22) 20%,\n        rgba(242, 248, 246, 0.15) 60%,\n        rgba(255, 255, 255, 0) 100%\n      );\n      animation: shimmer 2s infinite;\n      content: '';\n    }\n\n    @keyframes shimmer {\n      100% {\n        transform: translateX(100%);\n      }\n    }\n  }\n  @media screen and (max-width: 991px) {\n    width: calc(100% - 48px);\n    margin-left: auto;\n    margin-right: auto;\n  }\n  @media screen and (max-width: 700px) {\n    width: calc(100% - 32px);\n  }\n"
    ]);
    PreviousBetsTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PreviousBetsTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  .head-winning {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n  div {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.6);\n    font-weight: 400;\n    line-height: 140%;\n  }\n"
    ]);
    PreviousBetsTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PreviousBetsTable_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > div {\n    margin-top: 16px;\n  }\n"
    ]);
    PreviousBetsTable_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function PreviousBetsTable_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  .round {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 140%;\n    color: #fff;\n    display: flex;\n    align-items: center;\n  }\n  .direction {\n    @media screen and (max-width: 700px) {\n      display: flex;\n      align-items: center;\n    }\n  }\n  .winning {\n  }\n"
    ]);
    PreviousBetsTable_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var PreviousBetsTable = function(param) {
    var _numberOfBets = param.numberOfBets, numberOfBets = _numberOfBets === void 0 ? 5 : _numberOfBets, account = param.account, token = param.token, api = param.api;
    var ref;
    var ref1 = (0,react.useState)(false), isFetching = ref1[0], setIsFetching = ref1[1];
    var ref2 = (0,react.useState)(), betsLeaderboard = ref2[0], setBetsLeaderboard = ref2[1];
    var t = (0,localization_src/* useTranslation */.$G)().t;
    // const orderedBets = orderBy(betsLeaderboard?.bets, ['round.epoch'], ['desc'])
    (0,react.useEffect)(function() {
        var fetchBetHistory = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var response;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            setIsFetching(true);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            return [
                                4,
                                (0,helpers/* getBetLeaderboard */.QI)({
                                    id: account.toLowerCase()
                                }, numberOfBets, undefined, api, token.symbol)
                            ];
                        case 2:
                            response = _state.sent();
                            // const transformer = transformBetResponse(token.symbol)
                            setBetsLeaderboard(response.users[0]);
                            return [
                                3,
                                4
                            ];
                        case 3:
                            setIsFetching(false);
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchBetHistory() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchBetHistory();
    }, [
        account,
        numberOfBets,
        setIsFetching,
        api,
        token.symbol
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleTable, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleHead, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t("Round")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: t("Direction")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "head-winning",
                        style: {
                            textAlign: "right"
                        },
                        children: [
                            t("PnL"),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTooltip/* default */.Z, {
                                iconColor: "rgba(255,255,255,0.6)",
                                ml: "4px",
                                text: "Including claimed winnings, losses, and refund amounts. Unclaimed winnings are not included."
                            }),
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleBody, {
                children: isFetching ? times_default()(numberOfBets).map(function(num) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTr, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton-box"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton-box"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "skeleton-box"
                            })
                        ]
                    });
                }) : betsLeaderboard === null || betsLeaderboard === void 0 ? void 0 : (ref = betsLeaderboard.bets) === null || ref === void 0 ? void 0 : ref.map(function(bet) {
                    var isCancelled = bet.round.failed;
                    var isWinner = bet.position === bet.round.position;
                    var isProfit = isWinner && Number(bet.claimedNetETH) > 0;
                    // win but not claimed
                    var getAmount = function() {
                        if (isWinner && !bet.claimed) {
                            return null;
                        }
                        if (bet.claimedNetETH === null && !isCancelled) {
                            return Number(bet.amount) * -1;
                        }
                        if (isCancelled) {
                            return 0;
                        }
                        return Number(bet.claimedNetETH);
                    };
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTr, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "round",
                                children: bet.round.epoch.toLocaleString()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "direction",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PositionLabel, {
                                    position: bet.position
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "winning",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinningsView, {
                                    token: token,
                                    // amount={!isCancelled && isWinner ? bet.claimedNetBNB : bet.amount}
                                    amount: getAmount(),
                                    textPrefix: isCancelled ? "" : isProfit ? "+" : "",
                                    textColor: isCancelled ? "main" : isProfit ? "success" : "failure",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    subFontSize: "12px",
                                    subFontWeight: "400",
                                    color: "white",
                                    flexDirection: "column",
                                    subFontColor: "rgba(255, 255, 255, 0.60)"
                                })
                            })
                        ]
                    }, bet.id);
                })
            })
        ]
    });
};
var StyleTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-673318af-0"
})(PreviousBetsTable_templateObject());
var StyleHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-673318af-1"
})(PreviousBetsTable_templateObject1());
var StyleBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-673318af-2"
})(PreviousBetsTable_templateObject2());
var StyledTr = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-673318af-3"
})(PreviousBetsTable_templateObject3());
/* harmony default export */ var components_PreviousBetsTable = (PreviousBetsTable);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/MobileBetsTable.tsx

function MobileBetsTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 24px;\n  .label {\n    margin: 16px 0 8px 24px;\n  }\n  @media screen and (max-width: 700px) {\n    .label {\n      margin: 16px 0 8px 16px;\n    }\n\n    margin-right: 16px;\n  }\n"
    ]);
    MobileBetsTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var MobileBetsTable = function(param) {
    var account = param.account, token = param.token, api = param.api;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var handleToggle = function() {
        return setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FlexContainer, {
                alignItems: "center",
                justifyContent: "space-between",
                // px="24px"
                // py="32px"
                // borderBottom="1px solid"
                // borderColor="cardBorder"
                style: {
                    cursor: "pointer"
                },
                onClick: handleToggle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        className: "label",
                        as: "h5",
                        color: "#FFFFFF",
                        fontWeight: "700",
                        fontSize: "14px",
                        children: t("Last %num% Bets", {
                            num: 5
                        })
                    }),
                    !isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "arr",
                        src: "/images/leaderboard/arr.svg"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        alt: "arr",
                        style: {
                            transform: "rotate(180deg)"
                        },
                        src: "/images/leaderboard/arr.svg"
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PreviousBetsTable, {
                account: account,
                token: token,
                api: api
            })
        ]
    });
};
var FlexContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-2cf9b0a8-0"
})(MobileBetsTable_templateObject());
/* harmony default export */ var components_MobileBetsTable = (MobileBetsTable);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/DesktopBetsTable.tsx

function DesktopBetsTable_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* border: 1px solid ",
        "; */\n  height: fit-content;\n"
    ]);
    DesktopBetsTable_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DesktopBetsTable_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  align-items: center;\n"
    ]);
    DesktopBetsTable_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var StyledTableBorder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dc00f308-0"
})(DesktopBetsTable_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var DesktopBetsTable = function(param) {
    var account = param.account, token = param.token, api = param.api;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,react.useState)(true), isOpen = ref[0], setIsOpen = ref[1];
    var handleToggle = function() {
        return setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        p: "24px",
        pt: "16px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopBetsTable_FlexContainer, {
                alignItems: "center",
                justifyContent: "space-between",
                // px="24px"
                // py="32px"
                // borderBottom="1px solid"
                // borderColor="cardBorder"
                style: {
                    cursor: "pointer"
                },
                onClick: handleToggle,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    className: "label",
                    as: "h5",
                    color: "#FFFFFF",
                    fontWeight: "700",
                    fontSize: "14px",
                    children: t("Last %num% Bets", {
                        num: 5
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTableBorder, {
                children: account && isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_PreviousBetsTable, {
                    token: token,
                    api: api,
                    account: account
                })
            })
        ]
    });
};
var DesktopBetsTable_FlexContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-dc00f308-1"
})(DesktopBetsTable_templateObject1());
/* harmony default export */ var Results_DesktopBetsTable = (DesktopBetsTable);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/WalletStatsModal.tsx

function WalletStatsModal_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  > div {\n    max-width: calc((100% - 72px) / 3);\n  }\n\n  @media (max-width: 767px) {\n    /* flex-direction: column; */\n    display: grid;\n    grid-template-columns: 1fr;\n\n    padding: 16px;\n    gap: 12px;\n    > div {\n      max-width: unset;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      h6 {\n        margin-bottom: 0;\n      }\n      div:not(.tooltip) {\n        align-items: flex-end;\n      }\n    }\n  }\n"
    ]);
    WalletStatsModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function WalletStatsModal_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 700;\n  svg path {\n    fill: rgba(255, 255, 255, 0.6);\n  }\n  &:hover {\n    color: #03f5ae;\n    svg path {\n      fill: #03f5ae;\n    }\n  }\n"
    ]);
    WalletStatsModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function WalletStatsModal_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  width: 16px;\n"
    ]);
    WalletStatsModal_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function WalletStatsModal_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 460px;\n  background: #20233b;\n  @media (max-width: 767px) {\n    width: calc(100% - 32px);\n  }\n"
    ]);
    WalletStatsModal_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var StyledFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-6228924c-0"
})(WalletStatsModal_templateObject());
var ExternalLink = (0,styled_components_browser_esm/* default */.ZP)(LinkExternal/* default */.Z).withConfig({
    componentId: "sc-6228924c-1"
})(WalletStatsModal_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.text;
});
var StyledIconButton = (0,styled_components_browser_esm/* default */.ZP)(IconButton/* default */.Z).withConfig({
    componentId: "sc-6228924c-2"
})(WalletStatsModal_templateObject2());
var StyledModalContainer = (0,styled_components_browser_esm/* default */.ZP)(Modal_styles/* ModalContainer */.F0).withConfig({
    componentId: "sc-6228924c-3"
})(WalletStatsModal_templateObject3());
var WalletStatsModal = function(param) {
    var result = param.result, address = param.address, leaderboardLoadingState = param.leaderboardLoadingState, onDismiss = param.onDismiss, onBeforeDismiss = param.onBeforeDismiss, token = param.token, api = param.api;
    var ref, ref1;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var theme = (0,useTheme/* default */.ZP)().theme;
    var profile = (0,profile_hooks/* useProfileForAddress */.lC)(address).profile;
    var isLoading = leaderboardLoadingState === types/* FetchStatus.Fetching */.iF.Fetching;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var handleDismiss = function() {
        if (onBeforeDismiss) {
            onBeforeDismiss();
        }
        onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalContainer, {
        $minWidth: "320px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal_styles/* ModalHeader */.xB, {
                style: {
                    border: "none",
                    height: "80px",
                    background: "rgba(255, 255, 255, 0.10)"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        alignItems: "center",
                        style: {
                            flex: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                mr: "8px",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    alt: "avt",
                                    src: "/images/leaderboard/avt.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    (profile === null || profile === void 0 ? void 0 : profile.username) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        children: profile === null || profile === void 0 ? void 0 : profile.username
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExternalLink, {
                                        style: {
                                            textDecoration: "none"
                                        },
                                        href: (0,utils/* getBlockExploreLink */.C)(address, "address"),
                                        children: (0,truncateHash/* default */.Z)(address)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledIconButton, {
                        variant: "text",
                        onClick: handleDismiss,
                        "aria-label": "Close the dialog",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/leaderboard/close.svg",
                            alt: "link"
                        })
                    })
                ]
            }),
            result === null ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                p: "32px",
                textAlign: "center",
                fontWeight: "bold",
                children: t("No results found.")
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                maxHeight: [
                    "500px",
                    null,
                    null,
                    null,
                    null,
                    null,
                    "none"
                ],
                overflowY: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledFlex, {
                        p: " 16px 24px",
                        borderBottom: "1px solid rgba(255, 255, 255, 0.10) ",
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                        style: {
                                            display: "flex"
                                        },
                                        as: "h6",
                                        fontSize: "14px",
                                        color: "rgba(255, 255, 255, 0.60)",
                                        fontWeight: "400",
                                        mb: "8px",
                                        children: [
                                            t("PnL"),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTooltip/* default */.Z, {
                                                className: "tooltip",
                                                iconColor: "rgba(255,255,255,0.6)",
                                                ml: "4px",
                                                text: "Including claimed winnings, losses, and refund amounts. Unclaimed winnings are not included."
                                            })
                                        ]
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinningsView, {
                                        token: token,
                                        // amount={result?.netBNB}
                                        // textPrefix={result?.netBNB > 0 ? '+' : ''}
                                        // textColor={result?.netBNB > 0 ? 'success' : 'failure'}
                                        amount: result === null || result === void 0 ? void 0 : result.netETH,
                                        textPrefix: (result === null || result === void 0 ? void 0 : result.netETH) > 0 ? "+" : "",
                                        textColor: (result === null || result === void 0 ? void 0 : result.netETH) > 0 ? "success" : "failure",
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        subFontSize: "12px",
                                        subFontWeight: "400",
                                        color: "white",
                                        // alignItems="center"
                                        subFontColor: "rgba(255, 255, 255, 0.60)",
                                        flexDirection: "column",
                                        alignItems: "flex-start"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "h6",
                                        fontSize: "14px",
                                        color: "rgba(255, 255, 255, 0.60)",
                                        fontWeight: "400",
                                        mb: "8px",
                                        children: t("Win Rate")
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        children: "".concat(parseFloat(result === null || result === void 0 ? void 0 : result.winRate.toLocaleString(undefined, {
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 2
                                        })).toFixed(2), "%")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "h6",
                                        fontSize: "14px",
                                        color: "rgba(255, 255, 255, 0.60)",
                                        fontWeight: "400",
                                        mb: "8px",
                                        children: t("Rounds Won")
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        children: result === null || result === void 0 ? void 0 : (ref = result.totalBetsClaimed) === null || ref === void 0 ? void 0 : ref.toLocaleString()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        as: "h6",
                                        fontSize: "14px",
                                        color: "rgba(255, 255, 255, 0.60)",
                                        fontWeight: "400",
                                        mb: "8px",
                                        children: t("Rounds Played")
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        fontSize: "14px",
                                        fontWeight: "700",
                                        children: result === null || result === void 0 ? void 0 : (ref1 = result.totalBets) === null || ref1 === void 0 ? void 0 : ref1.toLocaleString()
                                    })
                                ]
                            })
                        ]
                    }),
                    isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_DesktopBetsTable, {
                        token: token,
                        api: api,
                        account: address
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_MobileBetsTable, {
                        token: token,
                        api: api,
                        account: address
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_WalletStatsModal = (WalletStatsModal);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/ResultAvatar.tsx





function ResultAvatar_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 8px;\n  &:hover div {\n    color: #03f5ae;\n  }\n"
    ]);
    ResultAvatar_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var UsernameWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-3323f40e-0"
})(ResultAvatar_templateObject());
var ResultAvatar = function(_param) {
    var user = _param.user, props = (0,_object_without_properties/* default */.Z)(_param, [
        "user"
    ]);
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var profile = (0,profile_hooks/* useProfileForAddress */.lC)(user.id).profile;
    var ref = (0,hooks/* useStatModalProps */.b1)(user.id), result = ref.result, address = ref.address, leaderboardLoadingState = ref.leaderboardLoadingState;
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), token = ref1.token, api = ref1.api;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_WalletStatsModal, {
        api: api,
        token: token,
        result: result,
        address: address,
        leaderboardLoadingState: leaderboardLoadingState
    }), true, false, "ResultAvatarWalletStatsModal"), 1), onPresentWalletStatsModal = ref2[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenu/* default */.Z, {
        component: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            alignItems: "center"
        }, props), {
            children: [
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: "/images/leaderboard/avt.svg",
                    alt: "avt",
                    width: "24px",
                    height: "24px"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(UsernameWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "white",
                            fontWeight: "400",
                            children: (profile === null || profile === void 0 ? void 0 : profile.username) || (0,truncateHash/* default */.Z)(user.id)
                        }),
                        " "
                    ]
                })
            ]
        })),
        options: {
            placement: "bottom-start"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SubMenuItem */.vE, {
                onClick: onPresentWalletStatsModal,
                children: t("View Stats")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SubMenuItem */.vE, {
                as: Link/* default */.Z,
                href: (0,utils/* getBlockExploreLink */.C)(user.id, "address"),
                bold: false,
                color: "text",
                external: true,
                children: t("View in Explorer")
            })
        ]
    });
};
/* harmony default export */ var Results_ResultAvatar = (ResultAvatar);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/DesktopRow.tsx




function DesktopRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 8px 24px 8px 0;\n"
    ]);
    DesktopRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DesktopRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  background: var(--Nature-1, #191b2e);\n\n  padding: 8px 16px;\n\n  td:first-child {\n    border-top-left-radius: 12px;\n    border-bottom-left-radius: 12px;\n  }\n  td:last-child {\n    border-top-right-radius: 12px;\n    border-bottom-right-radius: 12px;\n  }\n"
    ]);
    DesktopRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledTd = (0,styled_components_browser_esm/* default */.ZP)(Cell.Td).withConfig({
    componentId: "sc-dff51e80-0"
})(DesktopRow_templateObject());
var DesktopRow_StyledTr = styled_components_browser_esm/* default.tr.withConfig */.ZP.tr.withConfig({
    componentId: "sc-dff51e80-1"
})(DesktopRow_templateObject1());
var DesktopRow = function(_param) /*#__PURE__*/ {
    var rank = _param.rank, user = _param.user, props = (0,_object_without_properties/* default */.Z)(_param, [
        "rank",
        "user"
    ]);
    return (0,jsx_runtime.jsxs)(DesktopRow_StyledTr, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            rank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {
                style: {
                    paddingRight: "24px",
                    paddingLeft: "0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    textAlign: "center",
                    color: "white",
                    fontWeight: 700,
                    children: "#".concat(rank)
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_ResultAvatar, {
                    user: user
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinnings, {
                    fontWeight: "700",
                    fontSize: "14px",
                    subFontWeight: "400",
                    subFontSize: "12px",
                    amount: user.netETH,
                    textPrefix: user.netETH > 0 ? "+" : "",
                    textColor: user.netETH > 0 ? "success" : "failure",
                    flexDirection: "column",
                    alignItems: "flex-start"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {
                fontSize: "14px",
                fontWeight: "700",
                children: "".concat(parseFloat(user.winRate.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                })).toFixed(2), "%")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {
                fontSize: "14px",
                fontWeight: "700",
                children: user.totalBetsClaimed.toLocaleString()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTd, {
                fontSize: "14px",
                fontWeight: "700",
                children: user.totalBets.toLocaleString()
            })
        ]
    }));
};
/* harmony default export */ var Results_DesktopRow = (DesktopRow);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/DesktopResults.tsx

function DesktopResults_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    DesktopResults_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DesktopResults_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc((100% - 52px) / 5);\n  font-size: 14px;\n  padding-right: 24px;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: none;\n"
    ]);
    DesktopResults_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DesktopResults_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  table-layout: fixed;\n  border-collapse: separate;\n  border-spacing: 0 8px;\n"
    ]);
    DesktopResults_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






var StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8703ce37-0"
})(DesktopResults_templateObject());
var StyledTh = (0,styled_components_browser_esm/* default */.ZP)(Cell.Th).withConfig({
    componentId: "sc-8703ce37-1"
})(DesktopResults_templateObject1());
var DesktopResults = function(param) {
    var results = param.results;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        mb: "16px",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCard, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableStyle, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTh, {
                                    style: {
                                        paddingBottom: 0,
                                        paddingRight: "24px",
                                        paddingLeft: "0px",
                                        width: "76px"
                                    },
                                    children: "Top"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTh, {
                                    textAlign: "left",
                                    children: t("User")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTh, {
                                    textAlign: "left",
                                    children: t("PnL")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTh, {
                                    textAlign: "left",
                                    children: t("Win Rate")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTh, {
                                    textAlign: "left",
                                    children: t("Rounds Won")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTh, {
                                    textAlign: "left",
                                    children: t("Rounds Played")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: results.map(function(result, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_DesktopRow, {
                                rank: index + 4,
                                user: result
                            }, result.id);
                        })
                    })
                ]
            })
        })
    });
};
var TableStyle = (0,styled_components_browser_esm/* default */.ZP)(Table/* default */.Z).withConfig({
    componentId: "sc-8703ce37-2"
})(DesktopResults_templateObject2());
/* harmony default export */ var Results_DesktopResults = (DesktopResults);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/MobileRow.tsx

function MobileRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #191b2e;\n  border-radius: 16px;\n  padding: 24px;\n  &:not(:first-child) {\n    margin-top: 24px;\n    @media screen and (max-width: 700px) {\n      margin-top: 16px;\n    }\n    /* border-top: 1px solid ",
        "; */\n  }\n  @media screen and (max-width: 700px) {\n    padding: 16px;\n  }\n"
    ]);
    MobileRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var StyledMobileRow = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-5d683289-0"
})(MobileRow_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
});
var MobileRow = function(param) {
    var rank = param.rank, user = param.user, bg = param.bg;
    var ref;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledMobileRow, {
        style: {
            background: bg
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                mb: "8px",
                children: [
                    rank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "700",
                        children: "#".concat(rank)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_ResultAvatar, {
                        user: user
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "white60",
                        children: t("Win Rate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "bold",
                        children: "".concat((ref = Number(user.winRate.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 1
                        }))) === null || ref === void 0 ? void 0 : ref.toFixed(2), "%")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinningsRow, {
                amount: user.netETH
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "white60",
                        children: t("Rounds Won")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "bold",
                        children: "".concat(user.totalBetsClaimed.toLocaleString(), "/").concat(user.totalBets.toLocaleString())
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Results_MobileRow = (MobileRow);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/MobileResults.tsx

function MobileResults_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 24px;\n  margin-right: 24px;\n  margin-bottom: 16px;\n  @media screen and (max-width: 700px) {\n    margin-left: 16px;\n    margin-right: 16px;\n  }\n"
    ]);
    MobileResults_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var MobileResults = function(param) {
    var results = param.results;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleBox, {
        children: results.map(function(result, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_MobileRow, {
                rank: index + 4,
                user: result
            }, result.id);
        })
    });
};
var StyleBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-39e0e2e5-0"
})(MobileResults_templateObject());
/* harmony default export */ var Results_MobileResults = (MobileResults);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/RankingCard.tsx


function RankingCard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px;\n  height: unset;\n  position: relative;\n  border-radius: 16px;\n  .txt-dollar {\n    font-size: 14px;\n  }\n  > div {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n  }\n  .cup-img {\n    position: absolute;\n    top: -24px;\n    right: 0;\n    @media screen and (max-width: 700px) {\n      width: 80px;\n      height: 80px;\n    }\n  }\n  @media screen and (max-width: 700px) {\n    padding: 16px;\n  }\n"
    ]);
    RankingCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RankingCard_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  .rank-user {\n    .rank-address {\n      font-size: 16px;\n\n      font-weight: 700;\n      line-height: 140%;\n      margin-bottom: 4px;\n      color: #fff;\n      &:hover {\n        color: #03f5ae;\n      }\n    }\n    .rank-number {\n      font-size: 14px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 140%;\n      color: rgba(255, 255, 255, 0.6);\n    }\n  }\n"
    ]);
    RankingCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RankingCard_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 24px;\n  @media screen and (max-width: 700px) {\n    margin-bottom: 16px;\n  }\n"
    ]);
    RankingCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











var RankingCard_StyledCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-466d10b-0"
})(RankingCard_templateObject());
var CardHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-466d10b-1"
})(RankingCard_templateObject1());
var getRankingColor = function(rank) {
    if (rank === 3) {
        return "bronze";
    }
    if (rank === 2) {
        return "silver";
    }
    return "gold";
};
var RankingCard = function(param) {
    var rank = param.rank, user = param.user, bg = param.bg, icon = param.icon;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var rankColor = getRankingColor(rank);
    var profile = (0,profile_hooks/* useProfileForAddress */.lC)(user.id).profile;
    var ref = (0,hooks/* useStatModalProps */.b1)(user.id), result = ref.result, address = ref.address, leaderboardLoadingState = ref.leaderboardLoadingState;
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), token = ref1.token, api = ref1.api;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_WalletStatsModal, {
        api: api,
        token: token,
        result: result,
        address: address,
        leaderboardLoadingState: leaderboardLoadingState
    }), true, false, "RankingCardWalletStatsModal"), 1), onPresentWalletStatsModal = ref2[0];
    return(// <StyledCard ribbon={<CardRibbon variantColor={rankColor} text={`#${rank}`} ribbonPosition="left" />}>
    /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankingCard_StyledCard, {
        style: {
            background: bg
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleFlex, {
                flexDirection: "column",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardHead, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/leaderboard/avt.svg",
                            alt: "avt"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "rank-user",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenu/* default */.Z, {
                                    component: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "rank-address",
                                        children: (profile === null || profile === void 0 ? void 0 : profile.username) || (0,truncateHash/* default */.Z)(user.id)
                                    }),
                                    options: {
                                        placement: "bottom-start"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SubMenuItem */.vE, {
                                            onClick: onPresentWalletStatsModal,
                                            children: t("View Stats")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* SubMenuItem */.vE, {
                                            as: Link/* default */.Z,
                                            href: (0,utils/* getBlockExploreLink */.C)(user.id, "address"),
                                            bold: false,
                                            color: "text",
                                            external: true,
                                            children: t("View in Explorer")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "rank-number",
                                    children: [
                                        "Top #",
                                        rank
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "white60",
                        children: t("Win Rate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "bold",
                        color: "white",
                        fontSize: "14px",
                        children: "".concat(parseFloat(user.winRate.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2
                        })).toFixed(2), "%")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinningsRow, {
                amount: user.netETH
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "white60",
                        children: t("Rounds Won")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        fontWeight: "bold",
                        children: "".concat(user.totalBetsClaimed.toLocaleString(), "/").concat(user.totalBets.toLocaleString())
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: icon,
                alt: "cup",
                className: "cup-img"
            })
        ]
    }));
};
var StyleFlex = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({
    componentId: "sc-466d10b-2"
})(RankingCard_templateObject2());
/* harmony default export */ var Results_RankingCard = (RankingCard);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/index.tsx


function Results_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  font-size: 14px;\n  font-weight: 700;\n  padding: 8px 16px;\n  height: 40px;\n  color: white;\n  line-height: normal;\n"
    ]);
    Results_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Results_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 140%;\n  margin-bottom: 16px;\n  color: #fff;\n"
    ]);
    Results_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Results_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  gap: 24px;\n"
    ]);
    Results_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Results_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media screen and (max-width: 700px) {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n"
    ]);
    Results_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var Results_StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-4c45b714-0"
})(Results_templateObject());
var StyleTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-4c45b714-1"
})(Results_templateObject1());
var Results = function() {
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var ref = (0,_to_array/* default */.Z)((0,hooks/* useGetLeaderboardResults */.HF)()), first = ref[0], second = ref[1], third = ref[2], rest = ref.slice(3);
    var leaderboardLoadingState = (0,hooks/* useGetLeaderboardLoadingState */.AC)();
    var isLoading = leaderboardLoadingState === types/* FetchStatus.Fetching */.iF.Fetching;
    var currentSkip = (0,hooks/* useGetLeaderboardSkip */.Ok)();
    var hasMoreResults = (0,hooks/* useGetLeaderboardHasMoreResults */.Gy)();
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var handleClick = function() {
        dispatch((0,predictions/* filterNextPageLeaderboard */.Mk)(currentSkip + helpers/* LEADERBOARD_RESULTS_PER_PAGE */.ub));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleContainer, {
                mb: "32px",
                children: [
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyleTitle, {
                        children: "Total Rankings"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleGrid, {
                        gridTemplateColumns: [
                            "1fr",
                            null,
                            null,
                            null,
                            null,
                            "repeat(3, 1fr)"
                        ],
                        children: [
                            first && /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_RankingCard, {
                                rank: 1,
                                user: first,
                                icon: "/images/leaderboard/cup1.svg",
                                bg: "linear-gradient(0deg, #413302 0%, #1C1809 100%)"
                            }),
                            second && /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_RankingCard, {
                                rank: 2,
                                user: second,
                                icon: "/images/leaderboard/cup2.svg",
                                bg: "linear-gradient(180deg, #0A0D25 0%, #212870 100%)"
                            }),
                            third && /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_RankingCard, {
                                rank: 3,
                                user: third,
                                icon: "/images/leaderboard/cup3.svg",
                                bg: " linear-gradient(180deg, #011217 0%, #044A61 100%)"
                            })
                        ]
                    })
                ]
            }),
            isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_DesktopResults, {
                results: rest
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_MobileResults, {
                results: rest
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                paddingBottom: "120px",
                justifyContent: "center",
                children: hasMoreResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_StyledButton, {
                    variant: "secondary",
                    isLoading: isLoading,
                    onClick: handleClick,
                    children: isLoading ? t("Loading...") : t("View More")
                })
            })
        ]
    });
};
var StyleGrid = (0,styled_components_browser_esm/* default */.ZP)(Grid/* default */.Z).withConfig({
    componentId: "sc-4c45b714-2"
})(Results_templateObject2());
var StyleContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-4c45b714-3"
})(Results_templateObject3());
/* harmony default export */ var components_Results = (Results);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/MyRankingRow.tsx

function MyRankingRow_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  /* background: #191b2e;\n  border-radius: 16px;\n  padding: 24px;\n\n  @media screen and (max-width: 700px) {\n    padding: 16px;\n  } */\n"
    ]);
    MyRankingRow_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyRankingRow_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 330px repeat(4, 1fr);\n  color: #fff;\n  margin-top: 12px;\n  div.txt-bold {\n    font-size: 14px;\n\n    font-weight: 700;\n    line-height: 140%;\n  }\n"
    ]);
    MyRankingRow_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var MyRankingRow_StyledMobileRow = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-29cb9538-0"
})(MyRankingRow_templateObject());
var MyRankingRow = function(param) {
    var rank = param.rank, user = param.user;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    if (isDesktop) return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyleDesktop, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_ResultAvatar, {
                    user: user
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinnings, {
                    fontWeight: "700",
                    fontSize: "14px",
                    subFontWeight: "400",
                    subFontSize: "14px",
                    amount: user.netETH,
                    textPrefix: user.netETH > 0 ? "+" : "",
                    textColor: user.netETH > 0 ? "success" : "failure",
                    // flexDirection="column"
                    alignItems: "center"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "txt-bold",
                children: "".concat(parseFloat(user.winRate.toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                })).toFixed(2), "%")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "txt-bold",
                children: user.totalBetsClaimed.toLocaleString()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "txt-bold",
                children: user.totalBets.toLocaleString()
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MyRankingRow_StyledMobileRow, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                mb: "8px",
                children: [
                    rank ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "700",
                        children: "#".concat(rank)
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_ResultAvatar, {
                        user: user
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                mb: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "white60",
                        children: t("Win Rate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "bold",
                        children: "".concat(user.winRate.toLocaleString(undefined, {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2
                        }), "%")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NetWinningsRow, {
                amount: user.netETH
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "white60",
                        children: t("Rounds Won")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontWeight: "bold",
                        children: "".concat(user.totalBetsClaimed.toLocaleString(), "/").concat(user.totalBets.toLocaleString())
                    })
                ]
            })
        ]
    });
};
var StyleDesktop = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-29cb9538-1"
})(MyRankingRow_templateObject1());
/* harmony default export */ var Results_MyRankingRow = (MyRankingRow);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Results/ConnectedWalletResult.tsx

function ConnectedWalletResult_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 140%;\n  margin-bottom: 16px;\n  color: #fff;\n"
    ]);
    ConnectedWalletResult_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConnectedWalletResult_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  @media screen and (max-width: 700px) {\n    padding-left: 16px;\n    padding-right: 16px;\n    margin-bottom: 24px;\n  }\n"
    ]);
    ConnectedWalletResult_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ConnectedWalletResult_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 330px repeat(4, 1fr);\n  div {\n    color: rgba(255, 255, 255, 0.6);\n\n    font-size: 14px;\n    text-transform: none;\n    font-weight: 400;\n    line-height: 140%;\n  }\n\n  @media screen and (max-width: 967px) {\n    display: none;\n  }\n"
    ]);
    ConnectedWalletResult_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ConnectedWalletResult_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ConnectedWalletResult_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: fit-content;\n  width: 100%;\n  border-radius: 16px;\n\n  border-radius: 16px;\n  border: solid 1px transparent;\n  background: linear-gradient(#1b1e22 0 0) padding-box, linear-gradient(to right, #ff4fed, #03f5ae) border-box;\n\n  /* background: var(--Border, rgba(255, 255, 255, 0.1)); */\n  padding: 24px;\n\n  @media screen and (max-width: 967px) {\n    padding: 16px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var ConnectedWalletResult = function() {
    var account = (0,src/* useWeb3React */.Ge)().account;
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var accountResult = (0,hooks/* useGetOrFetchLeaderboardAddressResult */.nB)(account);
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var token = (0,ConfigProvider/* useConfig */.ZR)().token;
    (0,react.useEffect)(function() {
        if (account) {
            dispatch((0,predictions/* fetchAddressResult */.nI)(account));
        }
    }, [
        account,
        dispatch
    ]);
    if (!account || !accountResult) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectedWalletResult_StyleContainer, {
        mb: "48px",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedWalletResult_StyleTitle, {
                color: "white",
                children: t("My Rankings")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectedWalletResult_StyleTable, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ConnectedWalletResult_StyleHead, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: "\xa0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("PnL", {
                                    symbol: token.symbol
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("Win Rate")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("Rounds Won")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: t("Rounds Played")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectedWalletResult_StyleBody, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_MyRankingRow, {
                            user: accountResult
                        })
                    })
                ]
            })
        ]
    });
};
var ConnectedWalletResult_StyleTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-d097c313-0"
})(ConnectedWalletResult_templateObject());
var ConnectedWalletResult_StyleContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-d097c313-1"
})(ConnectedWalletResult_templateObject1());
var ConnectedWalletResult_StyleHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d097c313-2"
})(ConnectedWalletResult_templateObject2());
var ConnectedWalletResult_StyleBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d097c313-3"
})(ConnectedWalletResult_templateObject3());
var ConnectedWalletResult_StyleTable = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d097c313-4"
})(_templateObject4());
/* harmony default export */ var Results_ConnectedWalletResult = (ConnectedWalletResult);

// EXTERNAL MODULE: ./src/components/Select/Select.tsx
var Select = __webpack_require__(76688);
// EXTERNAL MODULE: ./src/components/AddressInputSelect/index.tsx
var AddressInputSelect = __webpack_require__(32711);
;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/AddressSearch.tsx












var AddressSearch = function() {
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    var ref = (0,hooks/* useStatModalProps */.b1)(), result = ref.result, address = ref.address, leaderboardLoadingState = ref.leaderboardLoadingState;
    var ref1 = (0,ConfigProvider/* useConfig */.ZR)(), token = ref1.token, api = ref1.api;
    var handleBeforeDismiss = function() {
        dispatch((0,predictions/* setSelectedAddress */.l3)(null));
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useModal/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_WalletStatsModal, {
        token: token,
        api: api,
        result: result,
        address: address,
        leaderboardLoadingState: leaderboardLoadingState,
        onBeforeDismiss: handleBeforeDismiss
    }), true, true, "AddressSearchWalletStatsModal"), 1), onPresentWalletStatsModal = ref2[0];
    var handleValidAddress = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var ref, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,predictions/* fetchAddressResult */.nI)(value))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            ((ref = response.payload) === null || ref === void 0 ? void 0 : ref.data) !== undefined
                        ];
                }
            });
        });
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch
    ]);
    var handleAddressClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dispatch((0,predictions/* setSelectedAddress */.l3)(value))
                        ];
                    case 1:
                        _state.sent();
                        onPresentWalletStatsModal();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAddressClick(value) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressInputSelect/* default */.Z, {
        onAddressClick: handleAddressClick,
        onValidAddress: handleValidAddress
    });
};
/* harmony default export */ var components_AddressSearch = (AddressSearch);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/components/Filters/index.tsx

function Filters_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 8px;\n  order: 1;\n  /*  */\n  width: 426px;\n\n  max-width: 100%;\n  margin-bottom: 0;\n  ",
        " {\n    margin-bottom: 0;\n    order: 2;\n  }\n"
    ]);
    Filters_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Filters_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  order: 2;\n  width: 100%;\n\n  ",
        " {\n    order: 1;\n    width: auto;\n  }\n"
    ]);
    Filters_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Filters_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 1px;\n  padding-bottom: 40px;\n  width: 1368px;\n  max-width: 100%;\n  padding-left: 24px;\n  padding-right: 24px;\n  margin: auto;\n  display: flex;\n  justify-content: space-between;\n  > div:first-child {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .Label {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    border: 1px solid transparent;\n    border-radius: 8px;\n    transition: border-radius 0.15s;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 120%;\n    margin-top: 1px;\n  }\n\n  @media screen and (max-width: 700px) {\n    padding-left: 16px;\n    padding-right: 16px;\n    flex-direction: column;\n    gap: 16px;\n    padding-bottom: 32px;\n  }\n"
    ]);
    Filters_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}








var SearchWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dede6c55-0"
})(Filters_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var FilterWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-dede6c55-1"
})(Filters_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.lg;
});
var Filters = function() {
    var t = (0,localization_src/* useTranslation */.$G)().t;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    // const { token } = useConfig()
    var orderByOptions = [
        {
            label: t("PnL"),
            value: "netETH"
        },
        {
            label: t("Rounds Played"),
            value: "totalBets"
        },
        {
            label: t("Total FTM"),
            value: "totalETH"
        },
        {
            label: t("Win Rate"),
            value: "winRate"
        }, 
    ];
    var handleOrderBy = function(option) {
        dispatch((0,predictions/* setLeaderboardFilter */.G$)({
            orderBy: option.value
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Filters_Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        className: "Label",
                        height: "48px",
                        style: {
                            whiteSpace: "nowrap"
                        },
                        textTransform: "uppercase",
                        fontSize: "14px",
                        color: "#FFFFFF99",
                        children: t("Rank By")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                            options: orderByOptions,
                            onOptionChange: handleOrderBy
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AddressSearch, {})
            })
        ]
    });
};
var Filters_Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dede6c55-2"
})(Filters_templateObject2());
/* harmony default export */ var components_Filters = (Filters);

;// CONCATENATED MODULE: ./src/views/Predictions/Leaderboard/index.tsx

function Leaderboard_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: linear-gradient(180deg, #04050b 0%, #01021a 100%);\n"
    ]);
    Leaderboard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}














var Leaderboard = function() {
    var leaderboardLoadingState = (0,hooks/* useGetLeaderboardLoadingState */.AC)();
    var filters = (0,hooks/* useGetLeaderboardFilters */.YY)();
    var account = (0,src/* useWeb3React */.Ge)().account;
    var dispatch = (0,useLocalDispatch/* default */.Z)();
    (0,react.useEffect)(function() {
        dispatch((0,predictions/* filterLeaderboard */.dG)({
            filters: filters
        }));
    }, [
        account,
        filters,
        dispatch
    ]);
    if (leaderboardLoadingState === types/* FetchStatus.Idle */.iF.Idle) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLoader/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* PageMeta */.V, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Hero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Filters, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_ConnectedWalletResult, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Results, {})
        ]
    });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b1b71a23-0"
})(Leaderboard_templateObject());
/* harmony default export */ var Predictions_Leaderboard = (Leaderboard);

;// CONCATENATED MODULE: ./src/pages/prediction/leaderboard.tsx



function leaderboard_Leaderboard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Predictions_Leaderboard, {});
}
leaderboard_Leaderboard.Layout = PredictionConfigProviders/* default */.Z;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5652,9774,2888,179], function() { return __webpack_exec__(67381); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);